import RangeType from "../../../types/RangeTypes";
import { Logger } from "../../../logging/logger";
import { MerchandisingProductView } from "../../../types/ContentfulTypes";
import { MpvProvider } from "../../../utils/MpvProvider";
import { getAction } from "../../../services/siteflow";
// @ts-ignore
import { ensureUserTestId } from "@vp/ab-test-cookie";
const getSiteflowGallery = async (props: {
  tenant: string;
  locale: string;
  mpv: MerchandisingProductView;
  selections: Record<string, string>;
  compatibleValues: Record<string, string[]>;
  compatibleRanges: Record<string, RangeType[]>;
  isMobile: boolean;
  quantity?: number;
  categories?: number[];
  logError?: boolean;
  studioDocumentUrl?: string;
}) => {
  const {
    tenant,
    locale,
    mpv,
    selections,
    quantity,
    categories,
    logError = true,
    compatibleValues,
    compatibleRanges,
    isMobile,
    studioDocumentUrl,
  } = props;

  const allOptionsAndValues = new MpvProvider(mpv).getAllOptionsAndValues();
  const allRanges = new MpvProvider(mpv).getAllRanges();
  const allSelections = getAllSelections({
    allOptionsAndValues,
    allRanges,
    selections,
    compatibleValues,
    compatibleRanges,
  });

  const siteflowInformation = await getAction({
    tenant,
    culture: locale,
    flowAction: "browsedesigns",
    productKey: mpv.coreProductId,
    version: mpv.version,
    optionValues: allSelections,
    quantity,
    optimizelyEndUserId: ensureUserTestId(),
    isMobile,
    urlTokens: {
      documentUrl: studioDocumentUrl,
    },
    mpvId: mpv.mpvId,
  });

  let finalUrl = siteflowInformation?.url;
  if (finalUrl) {
    finalUrl = finalUrl.replace(
      "&categories={galleryCategories}",
      categories && categories.length > 0 ? `&categories=${categories.join(",")}` : ""
    );
  } else {
    if (logError) {
      Logger.instance.error("Failed to construct gallery url with galleries", {
        locale,
        mpvId: mpv.mpvId,
        selections,
        quantity,
        finalUrl,
      });
    }
  }

  return finalUrl;
};

const getAllSelections = (props: {
  allOptionsAndValues: Record<string, string[]>;
  allRanges: Record<string, RangeType[]>;
  selections: Record<string, string>;
  compatibleValues: Record<string, string[]>;
  compatibleRanges: Record<string, RangeType[]>;
}): Record<string, string> => {
  const { allOptionsAndValues, allRanges, selections, compatibleValues, compatibleRanges } = props;
  const allSelections = Object.assign({}, selections);

  // Select all options that only have one value
  Object.entries(compatibleValues).forEach(([key, value]: [string, string[]]) => {
    if (!allSelections[`${key}`] && allOptionsAndValues[`${key}`] && value.length === 1) {
      allSelections[`${key}`] = compatibleValues[`${key}`][0];
    }
  });

  Object.entries(compatibleRanges).forEach(([key, range]: [string, RangeType[]]) => {
    if (
      !allSelections[`${key}`] &&
      allRanges[`${key}`] &&
      range.length === 1 &&
      range[0].minimum === range[0].maximum
    ) {
      allSelections[`${key}`] = String(range[0].minimum);
    }
  });

  return allSelections;
};

export { getSiteflowGallery, getAllSelections };
